export default "__VITE_ASSET__CKTDSN12__"